/**
 * 查询教参
 * 谢冉
 * 2020.8.25
 */
import '@instructure/canvas-theme';
import { Alert } from '@instructure/ui-alerts';
import { CondensedButton } from '@instructure/ui-buttons';
import { Button } from '@instructure/ui-buttons/es/Button';
import { FormField, FormFieldGroup } from '@instructure/ui-form-field';
import { Link } from '@instructure/ui-link';
import { Modal } from '@instructure/ui-modal';
import { Pagination } from '@instructure/ui-pagination';
import { RadioInput, RadioInputGroup } from '@instructure/ui-radio-input';
import { Table } from '@instructure/ui-table';
import { TextInput } from '@instructure/ui-text-input';
import { Tooltip } from '@instructure/ui-tooltip';
import { Text } from '@instructure/ui-text'
import React, { useEffect, useState } from 'react';
import { instance } from '../axios';
import '../css/SearchForm.css';
import '../css/SearchNoData.css';
import imgURL from '../images/u272.svg';
import EmailInfo from '../components/EmailInfo';
import ImportModal from '../components/ImportModal';

function SearchData(props) {
  const [alertToggle, setAlertToggle] = useState('none');
  const [rows, setRows] = useState([]);
  const [bookName, setBookName] = useState('');
  const [origin, setOrigin] = useState('');
  const [writer, setWriter] = useState('');
  const [pubDate, setPubDate] = useState('');
  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [alerts, setAlerts] = useState([]);
  const [bsId, setBsId] = useState();
  const [userId, setUserId] = useState();
  const [ghId, setGhId] = useState();
  // const [setNumber, setSetNumber] = useState();
  const [isTeacher, setIsTeacher] = useState();
  const [open, setOpen] = useState(false);
  const [selectValue, setSelectValue] = useState('教参');
  // const [localeType, setLocaleType] = useState('ZH');
  const [openDetail, setOpenDetail] = useState(false);
  const [visible, setvisible] = useState(false);

  const [info, setInfo] = useState({
    callno: '',
    language: '',
    jcmc: '',
    cbdw: '',
    zzxm: '',
    cbrq: '',
    isbn: '',
    csx: '',
    ys: '',
    bb: '',
  });

  useEffect(() => {
    const paramsString = props.location.search; //获取location的search属性，保存在search中
    let paramsObj = {}; //  创建一个空的对象来存储分割后的值
    if (paramsString !== '') {
      const params = paramsString.split('?'); // 将获取到的字符串按？分割
      const par = params[1]; // 分割完后为一个空的数组和？后面的一串，所以这里选择了数组的第一个值
      const paramsData = par.split('&'); // 再以&分割
      paramsData.map(e => {
        // 以&分割后是一个数组里包含两个对象，遍历这个数组，使里面的每个对象都以=分割，并把分割后的值放在空的对象中
        let newArr = e.split('=');
        paramsObj[newArr[0]] = newArr[1];
        return e;
      });
    }
    setBsId(paramsObj.courseId);
    setGhId(paramsObj.ghId);
    setUserId(paramsObj.userId);
    setIsTeacher(paramsObj.isTeacher);
  }, [props.location.search]);

  // 获取手动输入的值
  const handelChangeBookName = (e, value) => {
    setBookName(value);
  };
  const handelChangeOrigin = (e, value) => {
    setOrigin(value);
  };
  const handelChangeWriter = (e, value) => {
    setWriter(value);
  };
  const handelChangePubDate = (e, value) => {
    setPubDate(value);
  };

  //  如果是点击添加新教参进入教参编辑页面，则清空sessionStorage里的数据，以确保调用的是新增保存的按钮，
  //  因为编辑保存时有internalId,新增保存没有
  const onAddReferenceInfo = () => {
    let obj = {
      internalId: '',
      id: '',
      isbn: '',
      jcmc: '',
      cbdw: '',
      zzxm: '',
      cbrq: '',
      type: '教参',
      language: '',
      callno: '',
      bsId: bsId,
      userId: userId,
      isTeacher: isTeacher,
    };
    sessionStorage.setItem('paper_info', JSON.stringify(obj));
  };

  // 收起
  // const close = () => {
  //   setToggleBox('none');
  // }
  // // 打开
  // const open = () => {
  //   setToggleBox('block');
  // };

  //  重置
  const onClear = () => {
    setBookName('');
    setOrigin('');
    setWriter('');
    setPubDate('');
  };

  const pages = Array.from(Array(totalPage)).map((v, index) => (
    <Pagination.Page
      key={index}
      onClick={() => setCurrentPage(index)}
      current={index === currentPage}
    >
      {index + 1}
    </Pagination.Page>
  ));

  // 查询
  const onSearch = (type = 'ZH') => {
    // setLocaleType(type);
    let data = {
      jcmc: bookName,
      cbdw: origin,
      zzxm: writer,
      cbrq: pubDate,
      type,
    };
    instance({
      method: 'post',
      url: `getThesisSelective`,
      data: data,
    })
      .then(res => {
        const data = res?.data?.data || [];
        setCurrentPage(0);
        setTotalPage(Math.ceil(data.length / 10)); //  总页数
        setTotalCount(data.length); //  总条数
        setRows(data.map(item => ({ ...item, action: item})));
      })
      .catch(() => {});
  };

  //  添加
  const onOpen = rating => {
    setInfo({
      ...rating,
      callno: rating.callno,
      language: rating.language,
      jcmc: rating.jcmc,
      cbdw: rating.cbdw,
      zzxm: rating.zzxm,
      cbrq: rating.cbrq,
      isbn: rating.isbn,
    });
    setOpen(true);
  };

  // 添加取消关闭弹框
  const onClose = () => {
    setOpen(false);
    setInfo({
      callno: '',
      language: '',
      jcmc: '',
      cbdw: '',
      zzxm: '',
      cbrq: '',
      isbn: '',
    });
  };

  //  添加
  const onAdd = () => {
    let parameter = {
      ...info,
      isbn: info.isbn,
      jcmc: info.jcmc,
      cbdw: info.cbdw,
      zzxm: info.zzxm,
      cbrq: info.cbrq,
      bsid: bsId,
      status: 'enable',
      type: selectValue,
      language: info.language,
      callno: info.callno,
      gh: ghId,
    };
    const variants = ['success', 'error', 'info'];
    const politeness = ['添加成功', '添加失败', '该数据已添加'];
    const alert = [];
    instance({
      method: 'post',
      url: `operationKcThesisRelation`,
      data: parameter,
    })
      .then(res => {
        if (res.data.message === 'SUCCESS') {
          alert['politenessName'] = politeness[0];
          alert['variants'] = variants[0];
          setAlerts(alert);
          setAlertToggle('block');
          setTimeout(() => {
            setAlertToggle('none');
            setAlerts([]);
          }, 3000);
          setOpen(false);
        } else {
          setOpen(false);
          alert['politenessName'] = politeness[2];
          alert['variants'] = variants[2];
          setAlerts(alert);
          setAlertToggle('block');
          setTimeout(() => {
            setAlertToggle('none');
            setAlerts([]);
          }, 3000);
        }
      })
      .catch(() => {
        alert['politenessName'] = politeness[1];
        alert['variants'] = variants[1];
        setAlerts(alert);
        setAlertToggle('block');
        setTimeout(() => {
          setAlertToggle('none');
          setAlerts([]);
        }, 3000);
      });
  };

  // 打开详情弹框
  const onDetail = rating => {
    setInfo({
      ...rating,
      callno: rating.callno,
      language: rating.language,
      jcmc: rating.jcmc,
      cbdw: rating.cbdw,
      zzxm: rating.zzxm,
      cbrq: rating.cbrq,
      isbn: rating.isbn,
      csx: rating.csx,
      ys: rating.ys,
      bb: rating.bb,
      abstractInfo: rating.abstractInfo,
    });
    setOpenDetail(true);
  };

  //  关闭详情弹框
  const onCloseDetail = () => {
    setOpenDetail(false);
  };

  const renderCondensedButton = rating => (
  //  表格按钮
    <p style={{ display: 'flex', justifyContent: ' space-evenly' }}>
      {isTeacher && isTeacher === 'true' ? (
        <CondensedButton onClick={() => onOpen(rating)}>添加</CondensedButton>
      ) : (
        ''
      )}
      {/* <CondensedButton onClick={() => onCancelAdd(rating)}>移除</CondensedButton> */}
      <CondensedButton onClick={() => onDetail(rating)}>详情</CondensedButton>
    </p>
  );

  const headers = [
    {
      id: 'jcmc',
      text: '论文标题',
      width: '30%',
      textAlign: 'start',
    },
    {
      id: 'zzxm',
      text: '作者',
      width: '22%',
      textAlign: 'start',
    },
    {
      id: 'cbdw',
      text: '来源',
      width: '22%',
      textAlign: 'start',
    },
    {
      id: 'cbrq',
      text: '时间卷期',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'action',
      text: '操作',
      width: '15%',
      textAlign: 'center',
      renderCell: rating => renderCondensedButton(rating),
    },
  ];
  const inputs = [
    { value: 'guideBooks', label: '教参' },
    { value: 'material', label: '教材' },
  ];

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <div style={{ padding: '40px 0', overflow: 'hidden' }}>
        <FormFieldGroup colSpacing="large" layout="columns">
          <FormField layout="inline" label="论文标题:" id="bookName">
            <TextInput
              width="80%"
              placeholder="请输入"
              value={bookName}
              onChange={(e, value) => {
                handelChangeBookName(e, value);
              }}
            />
          </FormField>
          <FormField label="来源:" layout="inline" id="origin">
            <TextInput
              width="80%"
              placeholder="请输入"
              value={origin}
              onChange={(e, value) => {
                handelChangeOrigin(e, value);
              }}
            />
          </FormField>
        </FormFieldGroup>
        <div style={{ height: '20px' }} />
        <FormFieldGroup colSpacing="large" layout="columns">
          <FormField layout="inline" label="作者:" id="writer">
            <TextInput
              width="80%"
              placeholder="请输入任意一位作者即可"
              value={writer}
              onChange={(e, value) => {
                handelChangeWriter(e, value);
              }}
            />
          </FormField>
          <FormField label="时间卷期:" layout="inline" id="pubDate">
            <TextInput
              width="80%"
              placeholder="例如：2021,29(5):51-58或者2021"
              value={pubDate}
              onChange={(e, value) => {
                handelChangePubDate(e, value);
              }}
            />
          </FormField>
        </FormFieldGroup>
        <p className="line" style={{ margin: '15px' }}>
          <Button
            color="primary"
            size="large"
            margin="small"
            onClick={() => onSearch('ZH')}
          >
            查询中文
          </Button>
          <Button
            color="primary"
            size="large"
            margin="small"
            onClick={() => onSearch('EN')}
          >
            查询英文
          </Button>
          <Button
            color="primary-inverse"
            size="large"
            margin="small"
            onClick={() => onClear()}
          >
            重置
          </Button>
          {/* {toggleBox && toggleBox === 'block' ?
          <span
            style={{ color: 'blue', cursor: 'pointer' }}
            onClick={(e) => close()}>
            收起
          </span>
          :
          <span
            style={{ color: 'blue', cursor: 'pointer' }}
            onClick={(e) => open()}>
            打开
          </span>
        } */}
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {isTeacher && isTeacher === 'true' ? (
          <>
            <Button
              color="primary"
              margin="small"
              onClick={() => setvisible(true)}
            >
              + 批量添加电子论文
            </Button>
            <Tooltip
              renderTip="未查询到，请手动添加教参"
              offsetX="20"
              offsetY="10"
              placement="bottom"
            >
              <Link href="#/addPaper">
                <Button
                  color="primary"
                  margin="small"
                  onClick={() => onAddReferenceInfo()}
                >
                  + 手动添加电子论文
                </Button>
              </Link>
            </Tooltip>
          </>
          ) : (
            ''
          )}
        </div>
        <div
          style={
            rows && rows.length === 0
              ? { display: 'none' }
              : { display: 'block', marginTop: '35px' }
          }
        >
          <Table caption="Top rated movies">
            <Table.Head background="tiara">
              <Table.Row>
                {(headers || []).map(({ id, text, width, textAlign }) => (
                  <Table.ColHeader
                    key={id}
                    id={id}
                    width={width}
                    textAlign={textAlign}
                  >
                    {text}
                  </Table.ColHeader>
                ))}
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {rows &&
                rows.slice(currentPage * 10, (currentPage + 1) * 10).map(row => (
                  <Table.Row key={row.id}>
                    {headers.map(({ id, renderCell, textAlign }) => (
                      <Table.Cell key={id} textAlign={textAlign}>
                        {renderCell ? renderCell(row[id]) : row[id]}
                      </Table.Cell>
                    ))}
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
          <Modal open={open} size="small" label="Modal Dialog: 请选择类型">
            <Modal.Header>
              <p
                style={{
                  textAlign: 'center',
                  fontSize: '18px',
                  margin: '0px',
                  fontWeight: '700',
                }}
              >
                请选择类型
              </p>
            </Modal.Header>
            <Modal.Body>
              <RadioInputGroup
                name=""
                defaultValue="guideBooks"
                description=""
                layout="columns"
              >
                {inputs.map(input => (
                  <RadioInput
                    key={input.value}
                    value={input.value}
                    label={input.label}
                    onChange={() => setSelectValue(input.label)}
                  />
                ))}
              </RadioInputGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button margin="0 x-small 0 0" onClick={() => onClose()}>
                取消
              </Button>
              <Button color="primary" onClick={rating => onAdd(rating)}>
                确定
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal open={openDetail} size="medium" label="Modal Dialog: 单册详情">
            <Modal.Header>
              <p
                style={{
                  fontSize: '18px',
                  margin: '0px',
                  fontWeight: '700',
                }}
              >
                单册详情
              </p>
            </Modal.Header>
            <Modal.Body>
              <div style={{ display: 'flex' }}>
                <FormFieldGroup
                  description=""
                  layout="stacked"
                  rowSpacing="large"
                >
                  <FormField layout="inline" label="论文标题:">
                    {info.jcmc}
                  </FormField>
                  <FormField layout="inline" label="来源:">
                    {info.cbdw}
                  </FormField>
                </FormFieldGroup>
                <FormFieldGroup
                  description=""
                  layout="stacked"
                  rowSpacing="large"
                >
                  <FormField layout="inline" label="作者:">
                    {info.zzxm}
                  </FormField>
                  <FormField layout="inline" label="时间卷期:">
                    {info.cbrq}
                  </FormField>
                </FormFieldGroup>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '28px' }}>
                <div style={{width: '81px', textAlign: 'right'}}>
                  <Text weight='bold'>URL:</Text>
                </div>
                <div style={{width: 'calc(100% - 95px)'}}>
                  <FormField layout="inline" label="">
                    <Link href={info.doi} target="_blank">
                        {info.doi}
                    </Link>
                  </FormField>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '28px' }}>
                <div style={{width: '81px', textAlign: 'right'}}>
                  <Text weight='bold'>摘要:</Text>
                </div>
                <div style={{width: 'calc(100% - 95px)'}}>
                  <FormField label='' ayout="inline">{info.abstractInfo}</FormField>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button color="primary" onClick={rating => onCloseDetail(rating)}>
                关闭
              </Button>
            </Modal.Footer>
          </Modal>
          <p
          // style={
          //   rows && rows.length > 0 ? { display: 'block' } : { display: 'none' }
          // }
          >
            <p style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <span style={{ lineHeight: '60px' }}>
                总共 {totalCount} 个项目
              </span>
              <Pagination
                as="p"
                margin="small"
                variant="compact"
                labelNext="下一页"
                labelPrev="上一页"
              >
                {pages}
              </Pagination>
            </p>
          </p>
        </div>
        <div
          style={
            rows && rows.length === 0
              ? { display: 'block', marginTop: '35px' }
              : { display: 'none' }
          }
        >
          <div className="tips">
            <img src={imgURL} alt="" />
            <p className="tip">未查询到相关数据</p>
            <p className="message">建议您修改相关查询条件重新再试</p>
          </div>
        </div>
        <div
          style={
            alertToggle && alertToggle === 'block'
              ? {
                  display: 'block',
                  zIndex: '99',
                  position: 'fixed',
                  width: '30%',
                  bottom: '0',
                  right: '2% ',
                }
              : { display: 'none' }
          }
        >
          {
            <Alert
              variant={alerts.variants}
              margin="small"
              renderCloseButtonLabel="Close"
            >
              {alerts.politenessName}
            </Alert>
          }
        </div>
      </div>
      <EmailInfo />
      <ImportModal
        visible={visible}
        bsid={bsId}
        gh={ghId}
        onCancel={() => {
          setvisible(false);
        }}
        onSubmit={() => {
          setvisible(false);
        }}
      />
    </div>
  );
}

export default SearchData;
